import { ROOM_CONFIG_DESK } from "@validations/Inventory/roomConfig/roomConfigDeskValidation";

export function disabledRoomConfigDeskInput(
  inputRegName: string,
  setValue: any,
  isRoomConfig: boolean = true,
) {
  let roomConfig = Object.values(ROOM_CONFIG_DESK);
  if (!isRoomConfig) {
    roomConfig = Object.values(ROOM_CONFIG_DESK).filter(
      (item) => item !== ROOM_CONFIG_DESK.TYPE,
    );
  }
  const indexOfInputElm = roomConfig.indexOf(inputRegName);
  if (indexOfInputElm >= 0) {
    for (let i = indexOfInputElm + 1; i < roomConfig.length; i++) {
      const element = roomConfig[i];
      if (
        element === ROOM_CONFIG_DESK.DESK_NUMBER ||
        element === ROOM_CONFIG_DESK.PABX_NUMBER
      ) {
        setValue(element, null);
      } else {
        setValue(element, 0);
      }
    }
  }
}
